import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setCourseResults } from "../../repository/slice";

function* getCourseResultsWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setCourseResults(data));
        }
    } catch (error) {
        console.error("getCourseResultsWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getCourseResultsWatcher() {
    yield takeLatest("@saga/GET_COURSE_RESULTS", getCourseResultsWorker);
};